var alvoClass = document.querySelector('.topo');

var height = $(alvoClass).innerHeight();

$(window).scroll(function(){
	var body = document.body;

	var posicaoAtual = body.getBoundingClientRect().top;

	if($(this).scrollTop() > height){
		$(alvoClass).addClass('topo--fx');
		$('.btn-irtopo').addClass('fixo');
	}else{
		$(alvoClass).removeClass('topo--fx');
		$('.btn-irtopo').removeClass('fixo');
	}

});

